import React, { useCallback } from 'react'
import SeedCropDetailsForm, { FormData } from './SeedCropDetailsForm/SeedCropDetailsForm'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import SeedCropActions from 'modules/domain/seedCrop/duck'
import SeedCropSelectors from 'modules/domain/seedCrop/selectors'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import SeedCropRoutes from 'views/pages/SeedCrop/routes'
import { useAction, useHelmet, useHistoryPush } from '@agro-club/frontend-shared'

const SeedCropAdd: React.FC = () => {
  const { t } = useTranslation('seedCrop')
  const push = useHistoryPush()
  const seedCropAddAction = useAction(SeedCropActions.addRequested)
  const page = useSelector(SeedCropSelectors.page)

  const handleSubmit = useCallback(
    (fields: Required<FormData>) => {
      seedCropAddAction({
        name: fields.name,
      })
    },
    [seedCropAddAction],
  )

  const goBack = () => push({ route: SeedCropRoutes.List, query: { page } })
  const progress = useSelector(SeedCropSelectors.addProgress)

  useHelmet({ title: t('addSeedCropMetaTitle') })

  return (
    <>
      <Layout.Header>
        <Header.Root onClickBack={goBack}>
          <Header.Title size={'large'} title={t('form.add')} />
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <SeedCropDetailsForm onCancel={goBack} mode={'create'} onSubmit={handleSubmit} progress={progress} />
      </Layout.Content>
    </>
  )
}

export default SeedCropAdd
